import React, { Component } from 'react';

import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import { FormattedMessage } from '../../util/reactIntl';

const { Money } = sdkTypes;


export const getAdditionalFeeOptions = (params) => {
  const {
    intl,
    valuesArray,
    currency,
  } = params;


  return valuesArray.length > 0
    ? valuesArray.map((item, index) => {
      const formattedFee = formatMoney(intl, new Money(item.price*100, currency));

      const formattedLabel = (<FormattedMessage
        id='BookingTimeForm.additionalOptionLabel'
        values={{ fee: <span>{formattedFee}</span>, label: <span>{item.label}</span> }}
      />);
      return {
        key: item.label + '$' + item.price,
        label: formattedLabel,
      };
    }) : null;
};

export const getAdditionalFeeOptionsForProduct = (params) => {
  const {
    intl,
    valuesArray,
    currency,
  } = params;


  return valuesArray.length > 0
    ? valuesArray.map((item, index) => {
      const formattedFee = formatMoney(intl, new Money(item.price*100, currency));

      const formattedLabel = (<FormattedMessage
        id='BookingTimeForm.additionalOptionLabel'
        values={{ fee: <span>{formattedFee}</span>, label: <span>{item.label}</span> }}
      />);
      return {
        key: item.label + '$' + item.price,
        label: item.label,
      };
    }) : null;
};

